import React from 'react';
import {PropTypes} from 'prop-types';
import {Input, Textarea, RichTextarea} from 'components/danangtrade-forms/common';
import {SubCategoryInput} from 'components/danangtrade-forms';
import {Checkbox} from 'components/partials/checkbox';
import {Link, withRouter} from 'react-router-dom';
import style from './_ProductForm.scss';
import {MultipleImageUploader} from 'components/uploader';
import Promise from 'bluebird';
import {Products, Businesses, Fairs} from 'api';
import {toastr} from 'react-redux-toastr';
import {connect} from 'react-redux';
import {ShowIf} from 'components/utils';
import axios from 'axios';
import cookie from 'react-cookie';
import _ from 'lodash'

class ProductForm extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.props.validators['formPostProduct'] = [];

    this.state = {
      name: '',
      code: '',
      price: this.props.defaultPrice,
      description: '',
      introduction: '',
      images: [],
      categoryIds: [],
      listBusiness: [],
      dataCategory: [],
      businessId: '',
      customPrice: false,
      promotionalPrice: this.props.defaultPrice,
      customPromotionalPrice: false,
      isOnlyExistsFair: false,
      isOnlyApplyPromotionalPriceFair: false,
      initialIntroductionData: '',
      API_URL: '',
      access_token: cookie.load('accessToken') || '',
      categories: []
    }
  }

  bindData(data) {
    const {name, code, price, description, images, categoryIds, businessId, customPrice, introduction, promotionalPrice, isOnlyApplyPromotionalPriceFair} = data;

    this.setState({
      name, code, price, description, images, categoryIds, businessId, customPrice, introduction, promotionalPrice, isOnlyApplyPromotionalPriceFair, initialIntroductionData: introduction
    })
  }

  componentDidMount() {
    if (this.props.data) {
      this.bindData(this.props.data)
    }
    if (this.props.fair) {
      this.setState({
        API_URL: this.props.fair.apiUrl
      }, () => {
        this.getBusiness();
        this.getCategories()
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data != this.state.data) {
      this.bindData(nextProps.data);
    }
    if (this.props.fair !== nextProps.fair) {
      this.setState({
        API_URL: nextProps.fair.apiUrl
      }, () => {
        this.getBusiness();
        this.getCategories()
      })
    }
  }

  getCategories() {
    if (this.state.API_URL) {
      axios.get(`${this.state.API_URL}/categories`,{
        headers: {
          Authorization: `${this.state.access_token}`
        }
      }).then(response => {
        if (response.data) {
          this.setState({
            dataCategory: response.data,
            categories: this.getCategoryByTree(response.data)
          })
        }
      }).catch(error => {
        console.log(error)
      })
    }
  }

  getCategoryByTree(data) {
    let result = [...data].filter(item => item.parentId === null);
    result.map((item, index) => {
      result[index].children = [...data].filter(itemSub => itemSub.parentId === item.id)
    })
    return result
  }

  getBusiness() {
    if (this.state.API_URL) {
      let params = {
        filter: {
          where: {
            status: 1
          }
        }
      }
      axios.get(`${this.state.API_URL}/businesses`,{
        params,
        headers: {
          Authorization: `${this.state.access_token}`
        }
      }).then(response => {
        if (response.data) {
          this.setState({
            listBusiness: response.data
          })
        }
      }).catch(error => {
        console.log(error)
      })
    }
  }

  onChange(name, e) {
    if (name == 'typePrice') {
      if (this.state.typePrice == 'price') {
        this.setState({
          [name]: 'contact'
        })
      } else {
        this.setState({
          [name]: 'price'
        })
      }
    } else {
      this.setState({
        [name]: e.target.value
      })
    }
  }

  onUploadComplete(images) {
    this.setState({
      images
    });
  }

  submitForm(e) {
    //do something
    e.preventDefault();

    if (this.validateSubmitForm()) {
      let data = {
        products: [
          {
            name: this.state.name,
            code: this.state.code,
            price: this.state.price,
            description: this.state.description,
            introduction: this.state.introduction,
            images: this.state.images,
            categoryIds: this.state.categoryIds,
            businessId: this.state.businessId,
            dntCategoryIds: this.getDntCategoryIds(this.state.categoryIds),
            dntBusinessId: this.state.listBusiness[_.findIndex(this.state.listBusiness, (item) => item.id === this.state.businessId)].dntId,
            promotionalPrice: this.state.promotionalPrice,
            isOnlyExistsFair: this.state.isOnlyExistsFair,
            isOnlyApplyPromotionalPriceFair: this.state.isOnlyApplyPromotionalPriceFair
          }
        ]
      }
        console.log(data)
      Fairs.actions.addNewProducts.request({id: this.props.params.id},
        data
      ).then(response => {
        toastr.removeByType("success");
        toastr.success('Thành công!', 'Sản phẩm đã được thêm thành công.');
        //
        this.props.history.push(`/fair/${this.props.match.params.id}/products`);
      }).catch(err => {
        console.log(err)
      });
    }


    return false;
  }

  getDntCategoryIds(categoryIds) {
    let result = []
    categoryIds.map(item => {
      let index = _.findIndex(this.state.dataCategory, (itemCategory) => item === itemCategory.id)
      if (index != -1) {
        result.push(this.state.dataCategory[index].dntId)
      }
    })
    return result
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formPostProduct'].map(validator => {
      if (pass)
        pass = validator.validate();
      else
        validator.validate();
    });

    if (!this.state.businessId.trim()) {
      toastr.error('Lỗi!', 'Bạn vui lòng chọn doanh nghiệp cho sản phẩm');
      return false;
    }

    if (this.state.images.length == 0) {
      toastr.error('Lỗi!', 'Bạn vui lòng cung cấp ít nhất 1 hình ảnh cho sản phẩm');
      return false;
    }

    if (this.state.categoryIds.length == 0) {
      toastr.error('Lỗi!', 'Bạn vui lòng chọn ít nhất một nhóm sản phẩm cho sản phẩm hiện tại');
      return false;
    }

    if (!this.state.price.trim()) {
      toastr.error('Lỗi!', 'Bạn vui lòng nhập thông tin về giá');
      return false;
    }

    if (!this.state.promotionalPrice.trim()) {
      toastr.error('Lỗi!', 'Bạn vui lòng nhập thông tin về giá');
      return false;
    }

    return pass;
  }

  selectCategories(value) {
    let categoryIds = [];
    value.map(item => {
      categoryIds.push(item.value);
    });

    this.setState({
      categoryIds
    });
  }

  selectPrice(type) {
    if (type == 'custom') {
      this.setState({
        customPrice: true,
        price: ''
      });
    } else {
      this.setState({
        customPrice: false,
        price: this.props.defaultPrice
      });
    }
  }

  selectPromotionalPrice(type) {
    if (type == 'custom') {
      this.setState({
        customPromotionalPrice: true,
        promotionalPrice: ''
      });
    } else {
      this.setState({
        customPromotionalPrice: false,
        promotionalPrice: this.props.defaultPrice
      });
    }
  }

  onChangeCheckBox(name) {
    this.setState({
      [name]: !this.state[name]
    })
  }

  render() {
    return (
      <section className="add-product">
        <form onSubmit={this.submitForm.bind(this)}>
          <div className='add-product-wrap-form'>
            <div className='add-product-left-content'>
              <div className='wrap-select'>
                <select className='select-business' value={this.state.businessId} onChange={this.onChange.bind(this, 'businessId')}>
                  <option value=''>Chọn doanh nghiệp</option>
                  { this.state.listBusiness && this.state.listBusiness.map(item => {
                      return(<option value={item.id} key={item.id}>{item.name}</option>)
                    })
                  }
                </select>
              </div>
              <Input type="text" placeholder="Tên sản phẩm..."
                className='has-feedback fg-custom'
                value={this.state.name}
                required={"Tên sản phẩm không được để trống"}
                onChange={this.onChange.bind(this, 'name')}
                bindValidator={this} channel="formPostProduct"
                errorMessage="Tên sản phẩm không được để trống"
              />
              <MultipleImageUploader fnUpload={Products.actions.upload.request}
                type='PRODUCT'
                onUploadComplete={this.onUploadComplete.bind(this)}
                images={this.state.images}
              />

              <Input type="text" placeholder="Mã sản phẩm..."
                className='has-feedback fg-custom'
                value={this.state.code}
                onChange={this.onChange.bind(this, 'code')}
              />

              <Textarea type="text" placeholder="Mô tả..."
                heading={
                  () => <h3 className='wrap-product-des-title'>Mô tả ngắn <span className='des-title-des'><i className='fa fa-info-circle'/>Giới hạn trong 100 chữ.</span></h3>
                }
                className='wrap-product-des'
                inputClassName='product-des-input'
                iconFontSet='glyphicon'
                iconClassName='glyphicon-user'
                value={this.state.description}
                onChange={this.onChange.bind(this, 'description')}
                required={true}
                bindValidator={this} channel="formPostProduct"
                errorMessage="Bạn vui lòng nhập mô tả ngắn"
              />

              <RichTextarea type="text" placeholder="Mô tả..."
                heading={
                  () => <h3 className='wrap-product-des-title'>Giới thiệu về sản phẩm</h3>
                }
                className='wrap-product-des'
                inputClassName='product-des-input'
                iconFontSet='glyphicon'
                iconClassName='glyphicon-user'
                value={this.state.initialIntroductionData}
                onChange={this.onChange.bind(this, 'introduction')}
                required={true}
                bindValidator={this} channel="formPostProduct"
                errorMessage="Bạn vui lòng nhập mô tả ngắn"
              />
              <SubCategoryInput label="Chọn nhóm sản phẩm"
                onChange={this.selectCategories.bind(this)}
                data={this.state.categoryIds}
                categories={this.state.categories}
              />
            </div>

            <div className='add-product-right-content'>

              <div className='wrap-radio-price'>
                <h3 className='wrap-radio-price-title'>Giá sản phẩm</h3>
                <div className='wrap-input-radio-price'>
                  <input className='input-radio-price' id="customPrice" type='radio' onChange={this.selectPrice.bind(this, 'custom')} checked={this.state.customPrice} name='product-price'/>
                  <label className='label-radio-price' htmlFor="customPrice">Nhập giá (₫)</label>
                </div>
                <ShowIf condition={this.state.customPrice}>
                  <div className='content-justify wrap-price'>
                    <input className='input-price' onChange={this.onChange.bind(this, 'price')}/>
                  </div>
                </ShowIf>

                <div className='wrap-input-radio-price'>
                  <input className='input-radio-price' type='radio' id="contactPrice" onChange={this.selectPrice.bind(this, 'contact')} checked={!this.state.customPrice} name='product-price'/>
                  <label className='label-radio-price' htmlFor="contactPrice">Yêu cầu liên hệ</label>
                </div>

                <h3 className='wrap-radio-price-title'>Giá sản phẩm trên hội chợ</h3>
                <div className='wrap-input-radio-price'>
                  <input className='input-radio-price' id="customPromotionalPrice" type='radio' onChange={this.selectPromotionalPrice.bind(this, 'custom')} checked={this.state.customPromotionalPrice} name='product-promotional-price'/>
                  <label className='label-radio-price' htmlFor="customPromotionalPrice">Nhập giá (₫)</label>
                </div>
                <ShowIf condition={this.state.customPromotionalPrice}>
                  <div className='content-justify wrap-price'>
                    <input className='input-price' onChange={this.onChange.bind(this, 'promotionalPrice')}/>
                  </div>
                </ShowIf>

                <div className='wrap-input-radio-price'>
                  <input className='input-radio-price' type='radio' id="contactPromotionalPrice" onChange={this.selectPromotionalPrice.bind(this, 'contact')} checked={!this.state.customPromotionalPrice} name='product-promotional-price'/>
                  <label className='label-radio-price' htmlFor="contactPromotionalPrice">Yêu cầu liên hệ</label>
                </div>
                <div className='wrap-confirm'>
                  <div className='wrap-checkbox'>
                    <input type='checkbox' checked={this.state.isOnlyApplyPromotionalPriceFair ? true : false} onChange={this.onChangeCheckBox.bind(this, 'isOnlyApplyPromotionalPriceFair')}/>
                    <span className='checkbox-mark'></span>
                  </div>
                  <span className='confirm-text'>Giá chỉ áp dụng trên hội chợ</span>
                </div>
                <div className='wrap-confirm'>
                  <div className='wrap-checkbox'>
                    <input type='checkbox' checked={this.state.isOnlyExistsFair ? true : false} onChange={this.onChangeCheckBox.bind(this, 'isOnlyExistsFair')}/>
                    <span className='checkbox-mark'></span>
                  </div>
                  <span className='confirm-text'>Chỉ xuất hiện trên hội chợ</span>
                </div>
                {
                  this.props.edit ?
                    (
                      <div className='add-product-btn-wrap'>
                        <button className='add-product-btn'>Cập nhật sản phẩm</button>
                      </div>
                    ):(
                      <div className='add-product-btn-wrap'>
                        <button className='add-product-btn'>Đăng sản phẩm</button>
                      </div>
                    )
                }
              </div>
            </div>
          </div>
        </form>
      </section>
    );
  }
}

ProductForm.defaultProps = {
  validators: {},
  defaultPrice: 'Giá tham khảo'
}

const bindStateToProps = state => {
  return {
    auth: state.auth,
    businesses: state.myBusinesses,
    categories: state.categoriesAsTree
  }
}

export default withRouter(connect(bindStateToProps)(ProductForm));



// WEBPACK FOOTER //
// ./components/fair/fair-product/ProductForm.jsx